import axios from 'axios';


export default class PaymentWebservice {

  constructor() {
    this.url = '/payment-webservice';
  }

  getChargingLink(code) {
		return axios.get(this.url + `/credit-card/charging-link/${code}`);
	}

  authorize(sale) {
		return axios.post(this.url + '/credit-card/sales', sale);
	}

}



// WEBPACK FOOTER //
// ./src/services/PaymentWebservice.js